import usePrivateAxios from "@/common/api/usePrivateAxios"
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type"
import { getRailsUpdate } from "@/common/utils/getRailsUpdate"
import { mapToDeletion } from "@/common/utils/railsHelpers"
import { useMutation } from "@tanstack/react-query"
import { UpdateEstablishmentCompanyMaintenanceModelsValidationSchema } from "../../schemas/updateEstablishmentCompanyMaintenanceModels.schema"

interface UseUpdateEstablishmentCompanyMaintenanceModelsProps {
  establishmentCompany: EstablishmentCompanyData;
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentCompanyMaintenanceModels = ({
  establishmentCompany,
  onSuccess,
  onError,
}: UseUpdateEstablishmentCompanyMaintenanceModelsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentCompanyMaintenanceModels'],
    mutationFn: (data: UpdateEstablishmentCompanyMaintenanceModelsValidationSchema) => {
      const payload = {
        maintenance_infrastructures_attributes: getRailsUpdate(
          establishmentCompany.maintenance_infrastructures || [],
          data.maintenance_infrastructures || [],
          (x) => x.infrastructure_id,
          (y) => y.value,
          mapToDeletion,
          (z) => ({ infrastructure_id: z.value }),
        ),
        maintenance_technical_professionals_attributes: getRailsUpdate(
          establishmentCompany.maintenance_technical_professionals || [],
          data.maintenance_technical_professionals || [],
          (x) => x.technical_professional_id,
          (y) => y.value,
          mapToDeletion,
          (z) => ({ technical_professional_id: z.value }),
        ),
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompany.id}/update_maintenance_models`, {
        company: payload,
      })
    },
    onSuccess,
    onError,
  })
}
